export default "__VITE_ASSET__DUMldIVg__"